var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_253_2573",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.9053L20.9053 -4.46503e-08L41.8105 20.9053L20.9053 41.8105L0 20.9053Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.9053L-1.41421 19.4911L-2.82843 20.9053L-1.41421 22.3195L0 20.9053ZM1.41421 22.3195L22.3195 1.41421L19.4911 -1.41421L-1.41421 19.4911L1.41421 22.3195ZM22.3195 40.3963L1.41421 19.4911L-1.41421 22.3195L19.4911 43.2248L22.3195 40.3963Z",
    fill: "#9E9E9E",
    mask: "url(#path-1-inside-1_253_2573)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.4d1f274abf3ab814026db62549bca237.svg";
export { ForwardRef as ReactComponent };